import './ReferralEdit.scss'
import './Referral.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'
import SettingsSelect from 'manager/views/components/Settings/SettingsSelect.js'
import accounting from 'accounting-js'
import Select from 'react-select'
import { scrollToTop } from 'manager/util/helper'

import {
  TRANSACTION_TYPE, PRICE, FINANCING, PRICE_CUTOFFS, INTERNAL_PROPERTY_TYPE
} from 'common/constants'

import {
  updateTransaction
} from 'manager/redux/referral'

class ReferralEditTransaction extends Component {

  constructor(props) {
    super(props)

    const {
      referral: {
        name,
        transaction_name,
        transaction_type,
        desc,
        price_category,
        max_budget,
        override_financing_category,
        financing_category,
        property_category,
      },
      location
    } = props

    let is_edit = location.query.edit
    let default_transaction_type = location.query.type || 'buy'
    let type = is_edit ? 'edit' : 'add'

    this.state = {
      client_name: transaction_name || name,
      transaction_type: is_edit ? transaction_type : default_transaction_type,
      description: is_edit ? desc : null,
      type: type,
      price_category: price_category,
      max_budget: max_budget,
      financing_category: override_financing_category ? override_financing_category : financing_category && financing_category.startsWith('financing') ? 'financing' : financing_category,
      property_type: property_category,
      disabled: true,
    }
  }

  handleClick = async () => {
    const { dispatch, params } = this.props
    const { disabled } = this.state
    if (!disabled) {
      dispatch(updateTransaction(params.hash, this.state))
    }
    this.setState({disabled: true})
  }

  handleFieldChange = (field, value) => {
    if (this.state.type === 'edit') {
      this.setState({disabled: false})
    }
    this.setState({[field]: value}, this.updateDisabled)
  }

  handleBudgetChange = (value) => {
    if (this.state.type === 'edit') {
      this.setState({disabled: false})
    }

    let max_budget = Number(value)
    let price_category
    if (value === 0) {
      max_budget = null
      price_category = 'unknown'
    } else {
      var idx
      for (idx = 0; idx < PRICE_CUTOFFS.length; idx++) {
        if ((!PRICE_CUTOFFS[idx].min || PRICE_CUTOFFS[idx].min < max_budget) && (!PRICE_CUTOFFS[idx].max || max_budget <= PRICE_CUTOFFS[idx].max)) {
          price_category = PRICE_CUTOFFS[idx].category
        }
      }
    }
    this.setState({max_budget: max_budget, price_category: price_category}, this.updateDisabled)
  }

  updateDisabled = () => {
    const { type, client_name, description, financing_category, transaction_type, max_budget, price_category, property_type } = this.state
    const missingFinancingCategory = transaction_type === 'buy' && !financing_category
    if (type === 'add') {
      this.setState({disabled: !client_name || !description || missingFinancingCategory || !transaction_type || (!max_budget && !price_category)|| price_category === 'unknown' || !property_type })
    }
  }

  render() {
    const {
      location,
      referral: {
        transaction_name
      }
    } = this.props
    const { type, client_name, description, financing_category, transaction_type, max_budget, price_category, property_type, disabled } = this.state

    const show_warning_box = ((type === 'add') && !location.query.type) // Don't show warning box when they are coming from new question box on main referral view
    const show_budget = max_budget || price_category === 'unknown' || type === 'add' || transaction_type === 'lease'

    return <div className="ReferralTransaction">
      { show_warning_box && <div className="ReferralTransaction__row">
          <div className="ReferralTransaction__banner">
            <h4><i className="fa fa-warning" /> Notice</h4>
            <div>Please only add a transaction if you meet one of these criteria:</div>
            <ul>
              <li>Our client is a buyer who also wants to list their property</li>
              <li>Our client wishes to purchase additional property</li>
              <li>A transaction with another party resulted from an introduction to our client</li>
            </ul>
          </div>
        </div>
      }
      { transaction_name && (
          <div className="ReferralTransaction__row">
            <div className="ReferralTransaction__label">Transaction Name <span className="ReferralTransaction__required">*</span></div>
            <input 
              className="ReferralTransaction__input" 
              type="text" 
              value={client_name} 
              placeholder="Transaction Name" 
              onChange={(e) => (this.handleFieldChange('client_name', e.target.value))} 
              onFocus={scrollToTop}
            />
          </div>
        )
      }
      <div className="ReferralTransaction__row">
        <div className="ReferralTransaction__label">Transaction {show_budget ? 'Budget' : 'Price'} <span className="ReferralTransaction__required">*</span></div>
        { show_budget ?
          <input
            name="budget-input" 
            className="ReferralTransaction__input" 
            type="text" 
            value={max_budget ? accounting.formatMoney(max_budget, {precision: 0}) : null} 
            onChange={(e) => {this.handleBudgetChange(accounting.unformat(e.target.value))}} 
            placeholder={"$"} onFocus={scrollToTop}
          /> 
          :
          <Select
            value={price_category}
            options={PRICE}
            clearable={false}
            onChange={(value) => (this.handleFieldChange('price_category', value))}
            placeholder = "Select Price category"
          />
        }
      </div>
      { transaction_type === 'buy' && (
          <div className="ReferralTransaction__row">
            <div className="ReferralTransaction__label">Transaction Financing <span className="ReferralTransaction__required">*</span></div>
            <Select
              value={financing_category}
              onChange={value => this.handleFieldChange('financing_category', value.value)}
              clearable={false}
              searchable={false}
              options={FINANCING}
              placeholder="Select financing" 
            />
          </div>
        )
      }
      <div className="ReferralTransaction__row">
        <div className="ReferralTransaction__label">Transaction Type <span className="ReferralTransaction__required">*</span></div>
        <Select
          className="transaction-type-select"
          value={transaction_type}
          onChange={value => this.handleFieldChange('transaction_type', value.value)}
          clearable={false}
          searchable={false}
          options={TRANSACTION_TYPE}
          placeholder="Select type"
        />
      </div>
      <div className="ReferralTransaction__row">
        <div className="ReferralTransaction__label">Property Type <span className="ReferralTransaction__required">*</span></div>
        <Select
          className="property-type-select"
          value={property_type}
          onChange={value => this.handleFieldChange('property_type', value.value)}
          clearable={false}
          searchable={false}
          options={INTERNAL_PROPERTY_TYPE}
          placeholder="Select type"
        />
      </div>
      <div className="ReferralTransaction__row">
        <div className="ReferralTransaction__label">Transaction Description <span className="ReferralTransaction__required">*</span></div>
        <textarea 
          className="ReferralTransaction__textarea" 
          type="text"
          maxLength="25" 
          value={description} 
          placeholder="Short description" 
          onChange={(e) => (this.handleFieldChange('description', e.target.value))} 
          onFocus={scrollToTop}
        />
      </div>
      <div className="ReferralTransaction__footer">
        <Button
          className="button" 
          disabled={disabled}
          onClick={this.handleClick}
          bsStyle="success">
          Save
        </Button>
      </div>
    </div>
  }

}

export default ReferralEditTransaction
